import ErrorPage from '@/components/ErrorPage'
import { getCataloguePart1Response } from '@/helpers/TemplateHelper'
import { createCanonicalLink, getAgentConfiguration, isLanguageValid } from '@/helpers/UrlHelper'
import { PlpResponse } from '@/types'
import PlpPageTemplate from '@/components/PlpPageTemplate'
import BlogPageTemplate from '@/components/BlogPageTemplate'
import { logger } from '@/logging/Logger'

const log = logger()

type Part1Props = {
  plpResponse: PlpResponse
  canonicalLink: string
}

export default function Part1Page({ plpResponse, canonicalLink }: Part1Props) {
  if (plpResponse.error) {
    return <ErrorPage />
  }
  if (plpResponse.entityType === 'BLOGPAGE') {
    const { contentPageDetails } = plpResponse
    return <BlogPageTemplate contentPageDetails={contentPageDetails} canonicalLink={canonicalLink} />
  }

  if (plpResponse.entityType === 'REGION' || plpResponse.entityType === 'STATE') {
    const { agentConfiguration, entityDetails, entityType, templateDefinition, loyaltyCampaign } = plpResponse
    return (
      <PlpPageTemplate
        agentConfiguration={agentConfiguration}
        entityDetails={entityDetails}
        entityType={entityType}
        templateDefinition={templateDefinition}
        loyaltyCampaign={loyaltyCampaign}
        canonicalLink={canonicalLink}
      />
    )
  }

  log.info(`Could not find template for entityType='${plpResponse.entityType}'`)
  return <ErrorPage />
}

export async function getServerSideProps(context: {
  query: { lang: string; part1: string }
  req: { headers: { host: string } }
}) {
  const { lang, part1 } = context.query

  if (!isLanguageValid(lang)) {
    return { notFound: true }
  }

  const host = context.req.headers.host
  const agentConfiguration = getAgentConfiguration(host)
  const plpResponse = await getCataloguePart1Response(agentConfiguration, part1)
  const canonicalLink = createCanonicalLink(part1)

  if (plpResponse?.status === 404) {
    return {
      notFound: true,
    }
  }

  return { props: { plpResponse: plpResponse, canonicalLink: canonicalLink } }
}
